var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_6937",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.411731 4.21969C0.345141 4.24188 0.286115 4.28231 0.241367 4.33639C0.196619 4.39046 0.167945 4.45601 0.158607 4.52557C0.149269 4.59514 0.159642 4.66593 0.188546 4.72989C0.21745 4.79385 0.263724 4.84842 0.322105 4.88738L3.63826 6.71543C3.70007 6.74949 3.77023 6.76541 3.84068 6.76138C3.91114 6.75735 3.97902 6.73351 4.03654 6.69262L7.55952 4.18045C7.72976 4.06643 7.9334 4.27008 7.81938 4.44031L5.30721 7.96329C5.26632 8.02081 5.24248 8.0887 5.23845 8.15915C5.23442 8.2296 5.25034 8.29977 5.2844 8.36157L7.11245 11.6777C7.15141 11.7361 7.20598 11.7824 7.26994 11.8113C7.3339 11.8402 7.40469 11.8506 7.47426 11.8412C7.54382 11.8319 7.60937 11.8032 7.66344 11.7585C7.71752 11.7137 7.75795 11.6547 7.78014 11.5881L11.2273 1.24666C11.2492 1.18063 11.2524 1.1098 11.2363 1.04209C11.2203 0.974375 11.1858 0.912454 11.1366 0.863253C11.0874 0.814052 11.0255 0.77951 10.9577 0.763491C10.89 0.747472 10.8192 0.750608 10.7532 0.772549L0.411731 4.21969Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_6937)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.fcbd593171a5625c1fda5a8536ad6314.svg";
export { ForwardRef as ReactComponent };